import { setOptionsFromSdk } from '../../../../utils/push-notifications-utils';
import { unHideElement } from '../../../../utils/dom-utils';
import { retry } from '../../../../utils/retry';

const WPN_EDIT_LABEL = '#WPNEditLabel';

export const initInPage = async ({ actions, htmlProps, sdk, handlers, elementIdInPage }) => {
  retry({
    maxAttempts: 3,
    checkEvery: 5000,
    checkFunction: () => document.querySelector(WPN_EDIT_LABEL),
  })
    .then(() => {
      const $WPNEdit = document.querySelector(WPN_EDIT_LABEL);
      unHideElement($WPNEdit.parentNode);
      $WPNEdit?.addEventListener('click', () => {
        handlers.handleWPNEditInPageClick(elementIdInPage);
      });

      if (sdk?.channel?.optedIn) {
        setOptionsFromSdk({ sdk, selectBoxes: htmlProps.selectBoxes, actions });
      }
    })
    .catch((e) => console.error('[WPN] Edit label wont be shown', e));
};
